export default __webpack_public_path__ + "static/media/react.10c96f26.png";